import { activeDownloadJob, pauseDownload, resumeDownload } from '../storage/download-engine.js';

const SCOPE_LABELS: Record<string, string> = {
  book: 'This book',
  nt: 'New Testament',
  ot: 'Old Testament',
  full: 'Full Bible',
};

export function DownloadProgressBar() {
  const job = activeDownloadJob.value;
  if (!job || (job.status !== 'downloading' && job.status !== 'paused')) return null;

  const total = job.totalChapters > 0 ? job.totalChapters : 1;
  const completed = job.completedChapters;
  const pct = Math.min(100, Math.round((completed / total) * 100));
  const scopeLabel = SCOPE_LABELS[job.scope] ?? job.scope;

  return (
    <div class="dl-progress-bar-wrap" role="status" aria-label={`Downloading ${scopeLabel}`}>
      <div class="dl-progress-track">
        <div class="dl-progress-fill" style={{ width: `${pct}%` }} />
      </div>
      <div class="dl-progress-row">
        <span class="dl-progress-label">
          Saving {scopeLabel}… {completed} of {total}
        </span>
        {job.status === 'paused' ? (
          <button
            type="button"
            class="dl-progress-btn"
            onClick={resumeDownload}
            aria-label="Resume download"
          >
            Resume
          </button>
        ) : (
          <button
            type="button"
            class="dl-progress-btn"
            onClick={pauseDownload}
            aria-label="Pause download"
          >
            Pause
          </button>
        )}
      </div>
    </div>
  );
}
